import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SubNavbarComponent } from '@core/components/sub-navbar/sub-navbar.component';
import { INavRoute } from '@core/components/sub-navbar/sub-navbar.interface';
import { patientTypeSignalsNavigation } from '@core/constants/signals-navigation';

@Component({
  selector: 'app-patient-telediagnosis',
  imports: [RouterModule, SubNavbarComponent],
  templateUrl: './patient-telediagnosis.component.html',
  styleUrl: './patient-telediagnosis.component.scss',
})
export class PatientTelediagnosisComponent {
  public readonly routes: INavRoute[] = patientTypeSignalsNavigation;
}
